import { Link } from 'react-router-dom';

const footerLinks = {
  '分类浏览': [
    { label: '电影', to: '/category/dianying' },
    { label: '电视剧', to: '/category/dianshiju' },
    { label: '动漫', to: '/category/dongman' },
    { label: '综艺', to: '/category/zongyi' },
  ],
  '关于我们': [
    { label: '品牌介绍', to: '/about' },
    { label: '联系方式', to: '/about#contact' },
    { label: '用户口碑', to: '/about#testimonials' },
  ],
  '帮助中心': [
    { label: '常见问题', to: '/#faq' },
    { label: '观影指南', to: '/#faq' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-200/20">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">
                嫩草影院
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              嫩草影院是您最佳的在线影视观看平台，提供海量高清电影、电视剧、动漫等内容，支持免费流畅播放，无需注册即可享受优质观影体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-100 mb-4 font-heading">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/20 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 嫩草影院 nencaoyingyuan.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="微博">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="微信">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </div>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 transition-colors cursor-pointer" aria-label="QQ">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-qq-line"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}